import { connect } from 'react-redux';
import actions from 'actions/InCall/InCallVideo';
import { VIDEO_PRIMARY } from 'constants/InCall/InCallVideo';
import CallVideo from 'components/InCall/CallVideo/CallVideo';
import _get from 'lodash/get';
import { callSelectors } from '@lifesize/nucleus';

const mapActionCreators = dispatch => ({
  updateVideoRatio: videoId => dispatch(actions.updateVideoRatio(videoId)),
  onResizeVideo: (videoId, videoSize) => dispatch(actions.onResizeVideo(videoId, videoSize))
});

const mapStateToProps = (state) => {
  const activeCall = callSelectors.activeCallSelector(state);
  const hasVideo = _get(state, 'app.inCallVideo.shouldDisplayPrimaryVideo') && activeCall.hasIncomingVideo;
  const videoLayout = _get(state, 'app.inCallVideo.videoLayout');
  const videoContainerWidth = _get(videoLayout, ['videos', VIDEO_PRIMARY, 'container']);
  const videoWidth = _get(videoLayout, ['videos', VIDEO_PRIMARY, 'width']);
  const isMinimized = _get(state, 'app.inCallVideo.isMinimized');

  return ({
    hasVideo,
    isMinimized,
    videoElementId: VIDEO_PRIMARY,
    videoWidth,
    videoContainerWidth,
  });
};

export default connect(mapStateToProps, mapActionCreators)(CallVideo);
